import script from "./IndeterminateLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./IndeterminateLoader.vue?vue&type=script&setup=true&lang=js"

import "./IndeterminateLoader.vue?vue&type=style&index=0&id=66583663&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66583663"]])

export default __exports__